export default {
  title: 'התחשבנות חודשית של הסוכן {1}',
  dateInputLabel: 'תאריך תשלום',
  sum: 'סה״כ לתשלום {1} ₪',
  sendEmail: 'בוצע תשלום, שלח מייל',
  viewSummary: 'צפה בסיכום',
  moreInformation: 'צפייה במידע מפורט',
  verifySendingEmail: 'האם אתה בטוח שברצונך לשלוח את המייל?',
  verifySendingEmailMessage: 'לא יהיה ניתן לשנות את סטטוס התשלום',
  exportFileTitles: {
    commissions: '{3}_עמלות של הסוכן {1} לחודש {2}',
    additionalFees: '{3}_תשלומים נוספים של הסוכן {1} לחודש {2}',
    expenses: '{3}_הוצאות של הסוכן {1} לחודש {2}',
    monthlyPayment: '{3}_מידע מפורט {1} לחודש {2}',
  },
};
